import { as_record, extract_result_payload, normalize_session } from './facial_verification_field_shared';

export function build_result_request(props) {
  const question = props.question;
  if (!props.applicationFormId || !question?.id) {
    return null;
  }

  const request = {
    application_form_id: props.applicationFormId,
    section_question_id: question.id
  };
  return request;
}

export function apply_restored_result(state, emitters, payload) {
  const source = as_record(payload)?.data || payload;
  const data = extract_result_payload(source);
  if (!data) {
    return false;
  }

  state.result.value = data;
  state.step.value = 4;
  state.status_message.value = 'Verification already completed';
  emitters.emit_value();
  return true;
}

export function build_session_request(props) {
  const question = props.question;
  if (!props.applicationFormId || !question?.id) {
    return null;
  }

  const request = {
    application_form_id: props.applicationFormId,
    section_question_id: question.id,
    journey_reference: 'onboarding-intake'
  };
  return request;
}

export function apply_created_session(state, emitters, payload) {
  state.session.value = normalize_session(payload);
  state.status_message.value = 'Session ready';
  emitters.emit_value();
}

export function get_selected_file(event) {
  const target = event?.target;
  const file = target?.files?.[0];
  const result = file instanceof File ? { file, target } : null;
  return result;
}

export function validate_id_file(file) {
  const error_message = file.size > 8 * 1024 * 1024
    ? 'The selected ID image is larger than 8 MB.'
    : '';

  return error_message;
}

export function apply_selected_id(state, emitters, file, target) {
  state.id_file.value = file;
  emitters.revoke_preview_url();
  state.id_preview_url.value = URL.createObjectURL(file);
  state.local_error.value = '';
  emitters.emit_value();

  if (target) {
    target.value = '';
  }
}

export function build_upload_request(state) {
  const request = state.id_file.value && state.session.value?.session_id && state.session.value?.token
    ? {
        session_id: state.session.value.session_id,
        session_token: state.session.value.token,
        document: state.id_file.value
      }
    : null;

  return request;
}
